import { useEffect, useState } from 'react';

import { useSetAtom } from 'jotai';
import { timeZoneAtom } from '@/interfaces/utils';
import { settingPopOpenAtom } from '@/components/setting/users/ProfileSectionCard';

import styled from 'styled-components';
import { buttonBaseStyle } from '@/styles/constant';
import { Autocomplete, Button, TextField, Typography } from '@mui/material';

import { getTimeZones } from '@vvo/tzdb';
import { useTranslation } from 'react-i18next';

interface Props {
  timeZone: string;
}

const Layout = styled.div`
  padding: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export default function PopupSetTimeZone({ timeZone }: Props) {
  const { t } = useTranslation();
  const [tz, setTz] = useState(timeZone);
  const setTzAtom = useSetAtom(timeZoneAtom);
  const [tzList, setTzList] = useState([]);
  const setOpenTarget = useSetAtom(settingPopOpenAtom);

  useEffect(() => {
    setTzList(getTimeZones().map((item) => item.name));
  }, []);

  const handleCloseClick = () => {
    setTzAtom(tz);
    setOpenTarget({ open: '' });
  };

  return (
    <Layout>
      <Autocomplete
        id="TimeZone"
        options={tzList}
        fullWidth={true}
        defaultValue={tz}
        renderInput={(param) => <TextField {...param} label={t('Settings.label.timezone')} />}
        onChange={(e, value) => setTz(value)}
      />
      <Button
        variant="contained"
        sx={{
          ...buttonBaseStyle,
          width: 300,
          height: 44,
          borderRadius: 22,
        }}
        color="info"
        onClick={handleCloseClick}
      >
        <Typography fontWeight="medium">{t('Common.label.registButton')}</Typography>
      </Button>
    </Layout>
  );
}
